import { Cancel, ClockOutline, DesignPencil, SettingsProfiles } from 'iconoir-react';
import React from 'react'
import { STATE_STYLES } from './historical/stateStyles';

const iconStyle = { width: "1.1rem", height: "1.1rem", color: "white" };
const pillStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "0.6rem", padding: "0.3rem", color: "white", width: "7.4rem" };

// Ícono de cada estado en la tabla; el color sale de STATE_STYLES (compartido con el histórico)
const tableIcons = {
  "Por Firmar": DesignPencil,
  "Firmado": DesignPencil,
  "Recibida": DesignPencil,
  "Rechazado": Cancel,
  "En Proceso": ClockOutline,
  "Orden creada": SettingsProfiles,
  "Orden en Progreso": ClockOutline,
};

const iconLookup = Object.fromEntries(
  Object.entries(tableIcons).map(([state, Icon]) => [
    state,
    <div style={{ ...pillStyle, background: STATE_STYLES[state].color }}>{state} <Icon style={iconStyle} /></div>,
  ])
);

/*
const iconLookup = {
  "Por Firmar": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#f43f5e", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>Por Firmar <DesignPencil style={iconStyles.red} /></div>,
  "Firmado": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#f59e0b", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>Firmado <DesignPencil style={iconStyles.orange} /></div>,
  "Recibida": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#ea580c", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>Recibida <DesignPencil style={iconStyles.orange} /></div>,
  "Rechazado": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#f43f5e", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>Rechazado <Cancel style={iconStyles.red} /></div>,
  "En Proceso": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#60a5fa", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>En Proceso <ClockOutline style={iconStyles.blue} /></div>,
  "Orden creada": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#22c55e", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>Orden creada <SettingsProfiles style={iconStyles.green} /></div>,
  "Orden en Progreso": <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor:"#4338ca", borderRadius:"0.5rem", padding: "0.3rem", color: "white", width:"7.4rem"}}>Orden en Progreso <ClockOutline style={iconStyles.green} /></div>,
};

*/

export default function IconStateFun({tableMeta}) {
  let estado = tableMeta.is_actived;
  return (
    iconLookup[estado] || null
  );

}
